import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/Card';
import { useUserRole } from '../context/UserRoleContext';

export const AuthenticatedRoute = ({ children }) => {
  const { session, appUser, role, loading, profileError } = useUserRole();
  const location = useLocation();

  if (loading) {
    return (
      <Card>
        <CardContent className="py-14 text-center">
          <p className="text-sm text-slate-500">Kontrollerer innlogging og brukerprofil …</p>
        </CardContent>
      </Card>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (profileError || !appUser || appUser.status !== 'active' || !role) {
    return (
      <Card>
        <CardContent className="py-14 text-center">
          <h1 className="text-xl font-bold text-slate-900">Ingen aktiv tilgang</h1>
          <p role="alert" className="mt-2 text-sm text-slate-600">
            {profileError || 'En aktiv HMS-innsikt-brukerprofil er nødvendig. Kontakt administrator.'}
          </p>
        </CardContent>
      </Card>
    );
  }

  return children;
};

export const RoleRoute = ({ role: requiredRole, roles, children }) => {
  const { role, loading } = useUserRole();
  const allowedRoles = roles || [requiredRole];

  if (loading) {
    return (
      <Card>
        <CardContent className="py-14 text-center">
          <p className="text-sm text-slate-500">Kontrollerer tilgang …</p>
        </CardContent>
      </Card>
    );
  }

  if (!allowedRoles.includes(role)) {
    const requiredRoles = allowedRoles.join(' eller ');

    return (
      <Card>
        <CardContent className="py-14 text-center">
          <h1 className="text-xl font-bold text-slate-900">Ingen tilgang</h1>
          <p className="mt-2 text-sm text-slate-600">
            Denne siden krever rollen {requiredRole || requiredRoles}.
          </p>
        </CardContent>
      </Card>
    );
  }

  return children;
};